import React from 'react';
import classNames from 'classnames';
import { Errors } from 'react-redux-form';
import { formatText } from 'core/i18n';
import { RadioButtonOption } from './RadioButtonOption/RadioButtonOption';
import { useRadioButton } from './hooks/useRadioButton';

export const RadioButton = ({
    disabled = false,
    focusAnimated = false,
    formActions,
    isUpdated,
    label,
    messagesError = {
        required: formatText('validation-radioRequired'),
        valid: formatText('validation-text'),
    },
    model,
    onChange,
    onFocus,
    onKeyDown = null,
    optionsList,
    paymentStyle = {},
    profileModel,
    style = {},
    subtitle,
    tooltip,
    userProfile,
    userProfileForm,
}) => {
    const modelProp = model || profileModel.split('.')[1];
    const { classError, setTrigger } = useRadioButton({ userProfileForm, modelProp, isUpdated });

    const renderErrors = ({ children }) => {
        return <p className="form__field_error">{children}</p>;
    };

    const listClassName = classNames('form__radio-list', {
        ['form__input--error valid-error']: classError,
    });
    const showSubtitle = <label className="sub-label">{subtitle}</label>;
    const showLabel = (
        <label>
            {label}
            {tooltip}
        </label>
    );

    return (
        <div style={style} id={`id_wrapper_${modelProp}`}>
            {label && showLabel}
            {tooltip}
            {subtitle && showSubtitle}

            {optionsList.length && (
                <ul className={listClassName}>
                    {optionsList.map((option, index) => {
                        const id = `${modelProp}_${index}`;

                        return (
                            <RadioButtonOption
                                key={id}
                                id={id}
                                additionalComponent={option.additionalComponent}
                                change={formActions.change}
                                disabled={disabled}
                                focusAnimated={focusAnimated}
                                label={option.label}
                                model={model}
                                modelProp={modelProp}
                                onChange={onChange}
                                onFocus={onFocus}
                                onKeyDown={onKeyDown}
                                paymentStyle={paymentStyle}
                                profileModel={profileModel}
                                setTrigger={setTrigger}
                                setValidity={formActions.setValidity}
                                showAlwaysAdditionalComponent={option.showAlwaysAdditionalComponent}
                                userProfile={userProfile}
                                value={option.value}
                            />
                        );
                    })}
                </ul>
            )}
            <Errors model={profileModel} messages={messagesError} component={renderErrors} />
        </div>
    );
};
